module.exports = __webpack_public_path__ + "static/media/spaceheader.6185edb8.jpg";